import { ReactNode } from 'react'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// export const PostSheetsUpload = async (
//   multipartFile: Blob
// ): Promise<{ info: string } | { message: string }> => {
//   try {
//     const result = await apiService.post('app/venda/import', {
//       multipartFile,
//     })

//     if (result.status === 200) {
//       return { info: 'Planilha cadastrada com sucesso!' }
//     }
//   } catch (error) {
//     return catchError(error)
//   }

//   return {
//     message: 'Algo de errado aconteceu!',
//   }
// }

export const PostSheetsUpload = async (
  multipartFile: File
): Promise<{ info: string } | { message: string | ReactNode }> => {
  const formData = new FormData()
  formData.append('multipartFile', multipartFile)
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }

  try {
    const result = await apiService.post('app/venda/import', formData, config)
    if (result.status === 200) {
      return { info: 'Planilha cadastrada com sucesso!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
